"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var AccountEntry = function (props) { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(core_1.TextField, { id: "client-id", autoFocus: true, label: "Account ID", value: props.targetClientId || "", onChange: function (evt) { return props.accountChange(evt.target.value); }, margin: "normal" }),
    props.jumpError && (react_1.default.createElement(core_1.Typography, { color: "error" }, "Unable to switch account. Please check the account id")))); };
AccountEntry.propTypes = {
    targetClientId: prop_types_1.default.string,
    accountChange: prop_types_1.default.func,
    jumpError: prop_types_1.default.bool
};
exports.default = AccountEntry;
